import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=117763c0&scoped=true&"
import script from "./emptyPage.vue?vue&type=script&lang=js&"
export * from "./emptyPage.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./emptyPage.vue?vue&type=style&index=0&id=117763c0&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "117763c0",
  "2cad2e9e"
  
)

export default component.exports